module.exports = __webpack_public_path__ + "wealthmarket.2ff2096f992f857b3e5e6612c48952be.png";